export default __webpack_public_path__ + "static/media/Sign.3fa1527c.png";